import { Dictionary } from '@direct-frontend/stdlib';

export type ValueContainer<T> = {
    get: () => T;
    set: (value: Partial<T> | ((currentValue: T) => Partial<T>)) => void;
};

/** Создает контейнер для значения с возможностью его изменения */
export function createValueContainer<T extends Dictionary<unknown>>(defaultValue: NoInfer<T>): ValueContainer<T> {
    let currentValue: T = defaultValue;

    return {
        get: () => currentValue,
        set: valueOrUpdateFn => {
            const updatedValues =
                typeof valueOrUpdateFn === 'function' ? valueOrUpdateFn(currentValue) : valueOrUpdateFn;

            currentValue = {
                ...currentValue,
                ...updatedValues,
            };
        },
    };
}
